/* eslint-disable */
// third-party

// assets
import {
    IconDashboard,
    IconDeviceAnalytics,
    IconUsers,
    IconUserCircle,
    IconCalendarEvent,
    IconUserCheck,
    IconCreditCard,
    IconList,
    IconMail,
    IconArticle,
    IconGitPullRequest
} from '@tabler/icons';
import { roles } from 'store/constant';

const icons = {
    IconDashboard,
    IconDeviceAnalytics,
    IconUsers,
    IconCalendarEvent,
    IconUserCheck,
    IconUserCircle,
    IconCreditCard,
    IconList,
    IconMail,
    IconArticle,
    IconGitPullRequest
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'dashboard',
    title: 'dashboard',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        // {
        //     id: 'manage-account',
        //     title:  "My Account",
        //     type: 'item',
        //     url: '/user/account-profile',
        //     icon: icons.IconDashboard,
        //     breadcrumbs: false,
        //     restrict: [roles.VISITOR]
        // },
        {
            id: 'analytics',
            title: 'Analytics',
            type: 'item',
            url: '/dashboard/analytics',
            icon: icons.IconDeviceAnalytics,
            breadcrumbs: false,
            restrict: [roles.VISITOR]
        },
        {
            id: 'customers',
            title: 'Client',
            type: 'item',
            url: '/customers/list',
            breadcrumbs: false,
            icon: icons.IconUsers,
            restrict: [roles.VISITOR, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.APARTMENT_MANAGER]
        },
        {
            id: 'management',
            title: 'Management',
            type: 'collapse',
            icon: icons.IconCalendarEvent,
            children: [
                // {
                //     id: 'create-listing',
                //     title:  "Create Listing",
                //     type: 'item',
                //     url: '/listing/add',
                //     breadcrumbs: false,
                //     restrict: [roles.VISITOR]
                // },
                {
                    id: 'manage-listing',
                    title: 'Manage Listing',
                    type: 'item',
                    url: '/listing/manage-listing',
                    breadcrumbs: false,
                    restrict: [roles.VISITOR]
                },
                {
                    id: 'archived-listing',
                    title: 'Archived Listing',
                    type: 'item',
                    url: '/listing/archived-listing',
                    breadcrumbs: false,
                    restrict: [roles.VISITOR]
                },
                {
                    id: 'trashed-listing',
                    title: 'Trash Bin',
                    type: 'item',
                    url: '/listing/trashed-listing',
                    breadcrumbs: false,
                    restrict: [roles.VISITOR]
                },
                {
                    id: 'manage-users',
                    title: 'Managers',
                    type: 'item',
                    url: '/ams/manage-users',
                    breadcrumbs: false,
                    restrict: [roles.VISITOR, roles.ADMIN, roles.APARTMENT_MANAGER, roles.SUPER_ADMIN]
                },
                {
                    id: 'manage-users',
                    title: 'Share Access',
                    type: 'item',
                    url: '/rms/manage-users',
                    breadcrumbs: false,
                    restrict: [roles.VISITOR, roles.ADMIN, roles.MARKETING_MANAGER, roles.SUPER_ADMIN]
                }
            ]
        },
        {
            id: 'invoice',
            title: 'Invoice',
            type: 'collapse',
            icon: icons.IconCreditCard,
            restrict: [roles.VISITOR, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.APARTMENT_MANAGER],
            children: [
                {
                    id: 'create-invoice',
                    title: 'Create',
                    type: 'item',
                    url: '/invoices/add',
                    breadcrumbs: false
                    // restrict: [roles.VISITOR, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.APARTMENT_MANAGER]
                },
                {
                    id: 'invoices-list',
                    title: 'List',
                    type: 'item',
                    url: '/invoices/invoices-list',
                    breadcrumbs: false
                    // restrict: [roles.VISITOR, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.APARTMENT_MANAGER]
                }
                // {
                //     id: 'invoices-details',
                //     title:  "Details",
                //     type: 'item',
                //     url: '/invoices/invoices-details',
                //     breadcrumbs: false
                //     restrict: [roles.VISITOR, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.APARTMENT_MANAGER]
                // }
            ]
        }
        // {
        //     id: 'managers',
        //     title:  "Sub Managers," />,
        //     type: 'item',
        //     url: '/ams/manage-listing',
        //     breadcrumbs: false,
        //     icon: icons.IconUserCircle,
        //     restrict: [roles.VISITOR, roles.ADMIN, roles.APARTMENT_MANAGER, roles.SUPER_ADMIN]
        // },
        // {
        //     id: 'managers',
        //     title:  "Sub Managers",
        //     type: 'collapse',
        //     icon: icons.IconUserCircle,
        //     restrict: [roles.VISITOR, roles.ADMIN, roles.APARTMENT_MANAGER, roles.SUPER_ADMIN],
        //     children: [
        //         {
        //             id: 'manage-listing',
        //             title:  "Sub Managers," />,
        //             type: 'item',
        //             url: '/ams/manage-listing',
        //             breadcrumbs: false,
        //             restrict: [roles.VISITOR, roles.ADMIN, roles.APARTMENT_MANAGER, roles.SUPER_ADMIN]
        //         }
        //     ]
        // },
        // {
        //     id: 'regional-managers',
        //     title:  "Shared Listings",
        //     type: 'item',
        //     url: '/rms/shared-listing',
        //     breadcrumbs: false,
        //     icon: icons.IconUserCircle,
        //     restrict: [roles.VISITOR, roles.ADMIN, roles.SUPER_ADMIN]
        // }
        // {
        //     id: 'regional-managers',
        //     title:  "Shared Listings",
        //     type: 'collapse',
        //     icon: icons.IconUserCircle,
        //     restrict: [roles.VISITOR, roles.ADMIN, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.SUPER_ADMIN],
        //     children: [
        //         {
        //             id: 'manage-listing',
        //             title:  "Shared Listings",
        //             type: 'item',
        //             url: '/rms/shared-listing',
        //             breadcrumbs: false,
        //             restrict: [roles.VISITOR, roles.ADMIN, roles.MARKETING_MANAGER, roles.REGIONAL_MANAGER, roles.SUPER_ADMIN]
        //         }
        //     ]
        // }
        // {
        //     id: 'attendance',
        //     title:  "Attendance",
        //     type: 'collapse',
        //     icon: icons.IconUserCircle,
        //     children: [
        //         {
        //             id: 'attendance',
        //             title:  "Attendance",
        //             type: 'item',
        //             url: '/attendance/list',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'checkin',
        //             title:  "CheckIns",
        //             type: 'item',
        //             url: '/attendance/checkin',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'leave',
        //             title:  "Leave",
        //             type: 'item',
        //             url: '/attendance/leave',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'holiday',
        //             title:  "Holiday",
        //             type: 'item',
        //             url: '/attendance/holiday',
        //             breadcrumbs: false
        //         }
        //     ]
        // },
        // {
        //     id: 'payroll',
        //     title:  "Payroll",
        //     type: 'collapse',
        //     breadcrumbs: false,
        //     icon: icons.IconCreditCard,
        //     restrict: [roles.VISITOR],
        //     children: [
        //         {
        //             id: 'payrolls-list',
        //             title:  "Payroll List",
        //             type: 'item',
        //             url: '/payroll/list',
        //             breadcrumbs: false
        //         },
        //         {
        //             id: 'salary-slips',
        //             title:  "Salary Slips",
        //             type: 'item',
        //             url: '/payroll/salary-slips',
        //             breadcrumbs: false
        //         }
        //     ]
        // },
        // {
        //     id: 'letter-templates',
        //     title:  "Letter Templates",
        //     type: 'item',
        //     url: '/letter-templates/list',
        //     icon: icons.IconMail,
        //     breadcrumbs: false,
        //     restrict: [roles.VISITOR]
        // },
        // {
        //     id: 'docs',
        //     title:  "Documents",
        //     type: 'item',
        //     url: '/documents/list',
        //     icon: icons.IconArticle,
        //     breadcrumbs: false,
        //     restrict: [roles.VISITOR]
        // },
        // {
        //     id: 'logger',
        //     title:  "Logs",
        //     type: 'item',
        //     url: '/logger/list',
        //     breadcrumbs: false,
        //     icon: icons.IconList,
        //     restrict: [roles.VISITOR]
        // },
        // {
        //     id: 'requests',
        //     title:  "Requests",
        //     type: 'item',
        //     url: '/requests/list',
        //     breadcrumbs: false,
        //     icon: icons.IconGitPullRequest,
        //     restrict: []
        // }
    ]
};

export default dashboard;
